import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {
  COMPANY_STATUS_MANAGEMENT_URL,
  GET_ADD_SUBSCRIPTIONS_URL,
  GET_UPDATE_DELETE_SUBSCRIPTION_URL,
  SET_SUBSCRIPTION_ADDONS,
} from "../../constants/api/endpoints"
import { http } from "../../utils/http"
import { AxiosResponse } from "axios"
import { APIPaginatedResponseType, APIPaginationType } from "../../types/api/utils"
import { PricingFormType } from "../../types/PricingForm"
import { SubscriptionType } from "../../types/SubscriptionsType"
import { replaceIdInLink } from "@/utils/utils"
import { createAsyncPromo } from "@/redux/features/promosSlice"

// Fetch all subscription
export const fetchSubscriptions = createAsyncThunk<APIPaginatedResponseType<SubscriptionType> | SubscriptionType[], { pageIndex?: number }>(
  "subscriptions/fetchSubscriptions",
  async ({ pageIndex }, thunkApi) => {

    const url = pageIndex ? `${GET_ADD_SUBSCRIPTIONS_URL}?page=${pageIndex}` : GET_ADD_SUBSCRIPTIONS_URL
    return http
      .get<APIPaginatedResponseType<SubscriptionType> | SubscriptionType[]>(url)
      .then((res): APIPaginatedResponseType<SubscriptionType> | SubscriptionType[] => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  })

// Update an existing subscription
export const asyncUpdateSubscription = createAsyncThunk<SubscriptionType, {
  id?: string,
  data?: Partial<PricingFormType | FormData>,
}>(
  "subscription/asyncUpdateSubscription",
  async ({ id, data }: {
    id?: string,
    data?: Partial<PricingFormType | FormData>,
  }, thunkApi) => {
    return http
      .patch<SubscriptionType>(GET_UPDATE_DELETE_SUBSCRIPTION_URL.replace(":id", `${id}`), data)
      .then((res): SubscriptionType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)


// Update an existing company' from subscription
export const asyncManageCompanyStatusFromSubscription = createAsyncThunk<any, {
  companyId: string,
  data?: { todo: string },
}>(
  "subscription/asyncManageCompanyStatusFromSubscription",
  async ({ companyId, data }: {
    companyId: string,
    data?: { todo: string },
  }, thunkApi) => {
    return http
      .post(COMPANY_STATUS_MANAGEMENT_URL.replace(":id", `${companyId}`), data)
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Delete an existing subscription
export const deleteAsyncSubscription = createAsyncThunk<AxiosResponse, { id: string }>(
  "subscription/deleteAsyncSubscription",
  async ({ id }: { id: string }, thunkApi) => {
    return http
      .delete<AxiosResponse>(GET_UPDATE_DELETE_SUBSCRIPTION_URL.replace(":id", id))
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)
const initialSubscriptionState =[
  {
    "id": "a0396648-4e1e-4f31-806d-a78b13a17517",
    "plan": {
      "id": "a347a3ce-bf6b-49ed-ae92-7fe69b6eace3",
      "is_deleted": false,
      "deleted_at": null,
      "name": "Extra Plan",
      "description": "Our best plan",
      "base_price": 1000,
      "price_by_collabo": 50,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2025-12-01T14:16:02.271360Z",
    "status": "ACTIVE",
    "collabos_number": 12,
    "start_date": "2025-12-01",
    "end_date": "2025-12-01",
    "payment_periodicity": 1,
    "created_at": "2025-12-23T17:13:01.357413Z",
    "updated_at": "2025-12-23T17:13:01.357425Z",
    "company": "498f8e74-9c5b-440b-a281-8b20634adc45",
    "addons": [
      "f8a9b0c1-d2e3-4f4a-5b6c-7d8e9f0a1b2c"
    ]
  },
  {
    "id": "ce2af616-9b52-4872-9d88-fd2f20bc8abe",
    "plan": {
      "id": "e49fc20e-4c5e-46af-87d3-3d902661f01b",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STARTER",
      "description": "Pour les startups qui ont moins de 10 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2024-05-03T23:30:36.609279Z",
    "status": "ACTIVE",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "c2fa06ad-c9b2-4852-8978-41c909611522",
    "addons": []
  },
  {
    "id": "638f9f9d-dfb2-487d-a100-bbd9ed563267",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-12-04T14:25:28.018490Z",
    "status": "ACTIVE",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "46c550ad-3178-45cd-858b-cf337b686d37",
    "addons": []
  },
  {
    "id": "a9f1ea58-b2bf-4c45-b404-4c9cee8848e1",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-10-12T09:50:26.316159Z",
    "status": "ACTIVE",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "f46e9816-1571-48eb-8f6b-99362080a6bc",
    "addons": []
  },
  {
    "id": "4a3606e2-a83e-4372-ad98-d606cd44f5dd",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-07-04T09:58:18.843730Z",
    "status": "ACTIVE",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "7838eea3-b67c-4362-bd55-19376f3396f1",
    "addons": []
  },
  {
    "id": "38517d9d-352b-480c-9a51-fef46a85a066",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-07-04T09:57:12.044483Z",
    "status": "EXPIRED",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "498f8e74-9c5b-440b-a281-8b20634adc45",
    "addons": []
  },
  {
    "id": "6af61fcd-b52e-4cca-87a1-48cb6a869afa",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-06-22T16:03:31.393915Z",
    "status": "ACTIVE",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "a4242f5a-5aa3-48fb-b7e3-815dfc0b4779",
    "addons": []
  },
  {
    "id": "1496004f-59fc-4ef1-8e2a-32544bbec924",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-05-10T10:11:14.784418Z",
    "status": "ACTIVE",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "4ac6be1f-7f03-4fbb-9551-0f0214c14534",
    "addons": []
  },
  {
    "id": "a2bfe6ac-44f5-4e70-b866-d344ad1cd491",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-05-10T10:09:23.273818Z",
    "status": "ACTIVE",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "8ea9f984-cc9d-44f5-b5c8-1effc4b5c49f",
    "addons": []
  },
  {
    "id": "881cb832-bc3b-4b80-9e65-90585cf3d2f2",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-05-10T10:03:07.989051Z",
    "status": "EXPIRED",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "c2fa06ad-c9b2-4852-8978-41c909611522",
    "addons": []
  },
  {
    "id": "5d43623e-7295-4b99-83c3-c80b00e1a8cc",
    "plan": {
      "id": "afe46fb2-7683-43b5-ba7d-e19faeec2fa6",
      "is_deleted": false,
      "deleted_at": null,
      "name": "STANDARD",
      "description": "Pour les startups qui ont entre 10 et 50 employés. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultricies cursus",
      "base_price": null,
      "price_by_collabo": null,
      "status": "ACTIVE",
      "options": []
    },
    "is_deleted": false,
    "deleted_at": null,
    "subscribe_at": "2023-05-09T06:00:47.626457Z",
    "status": "ACTIVE",
    "collabos_number": 0,
    "start_date": null,
    "end_date": null,
    "payment_periodicity": 1,
    "created_at": "2025-12-01T11:30:03.227919Z",
    "updated_at": "2025-12-01T11:30:03.252177Z",
    "company": "faf76de1-bfbc-403c-9502-7a2176744ef8",
    "addons": []
  }
]


// Set subscription addons
export const setSubscriptionAddons = createAsyncThunk<SubscriptionType, { subscriptionId: string, addons : string[] }>(
  "subscription/setSubscriptionAddons",
  async ( { subscriptionId, addons }:{ subscriptionId: string, addons : string[] }, thunkApi) => {
    return http
      .post<SubscriptionType>(SET_SUBSCRIPTION_ADDONS.replace(":id", subscriptionId), {
        "addons": addons,
      })
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)


// initial state
const initialState: {
  subscriptions: any,
  pagination?: APIPaginationType
  subscriptionsStatus: string,
  subscriptionsErrors?: any,

  addSubscriptionStatus: string,
  addSubscriptionErrors?: any,

  deleteSubscriptionErrors?: any,
  deleteSubscriptionStatus: string,
} = {
  subscriptions: initialSubscriptionState,
  subscriptionsStatus: "idle",
  addSubscriptionStatus: "idle",
  deleteSubscriptionStatus: "idle",
}

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {},

  extraReducers(builder) {
    // get  all subscriptions
    // Todo handle pagination
    builder
      .addCase(fetchSubscriptions.pending, (state) => {
        state.subscriptionsStatus = "loading"
      })
      .addCase(fetchSubscriptions.fulfilled, (state, action) => {
        state.subscriptionsStatus = "succeeded"
        if ("results" in action.payload) {
          const { results, ...pagination } = action.payload
          state.subscriptions = results
          state.pagination = pagination
        } else {
          state.subscriptions = action.payload
        }
      })
      .addCase(fetchSubscriptions.rejected, (state, action) => {
        state.subscriptionsStatus = "failed"
        state.subscriptionsErrors = action.error
      })
    builder
      .addCase(asyncUpdateSubscription.pending, (state) => {
        state.subscriptionsStatus = "loading"
      })
      .addCase(asyncUpdateSubscription.fulfilled, (state, action) => {
        state.subscriptionsStatus = "succeeded"
        let index = state.subscriptions.findIndex(subscription => subscription.id === action.meta.arg.id)
        if (index >= 0) {
          state.subscriptions.splice(index, 1)
          state.subscriptions.unshift(action.payload)
        }

      })
      .addCase(asyncUpdateSubscription.rejected, (state, action) => {
        state.subscriptionsStatus = "failed"
        state.subscriptionsErrors = action.error
      })

    builder
      .addCase(asyncManageCompanyStatusFromSubscription.pending, (state) => {
        state.subscriptionsStatus = "loading"
      })
      .addCase(asyncManageCompanyStatusFromSubscription.fulfilled, (state, action) => {
        state.subscriptionsStatus = "succeeded"
        state.subscriptions = state.subscriptions.map((subscription) => {
          if (subscription.company.id === action.meta.arg.companyId) {
            return { ...subscription, company: action.payload }
          }
          return subscription
        })

      })
      .addCase(asyncManageCompanyStatusFromSubscription.rejected, (state, action) => {
        state.subscriptionsStatus = "failed"
        state.subscriptionsErrors = action.error
      })

    builder
      .addCase(deleteAsyncSubscription.pending, (state) => {
        state.deleteSubscriptionStatus = "loading"
      })
      .addCase(deleteAsyncSubscription.fulfilled, (state, action) => {
        state.subscriptionsStatus = "succeeded"
        state.subscriptions = state.subscriptions.filter((subscription) => subscription.id !== action.meta.arg.id)
      })
      .addCase(deleteAsyncSubscription.rejected, (state, action) => {
        state.deleteSubscriptionStatus = "failed"
        state.deleteSubscriptionErrors = action.error
      })

    builder
      .addCase(setSubscriptionAddons.pending, (state) => {
        state.subscriptionsStatus = "loading"
      })
      .addCase(setSubscriptionAddons.fulfilled, (state, action) => {
        state.subscriptionsStatus = "succeeded"
        let index = state.subscriptions.findIndex(sub => sub.id === action.meta.arg.subscriptionId)
        state.subscriptions[index] = action.payload

      })
      .addCase(setSubscriptionAddons.rejected, (state, action) => {
        state.subscriptionsStatus = "failed"
        state.subscriptionsErrors = action.error
      })
  },
})

export default subscriptionsSlice.reducer

